import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOverwriteEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9764.31,
			cy: 1778.71,
			r: 236.614,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 62.74,
			transform: "translate(-10857.3 -1529.3)scale(1.14763)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.00230619999999,
			d: "M511.978 295.26c45.503-34.395 102.15-54.811 163.537-54.811 149.87 0 271.518 121.683 271.518 271.552s-121.649 271.54-271.518 271.54c-61.387 0-118.034-20.404-163.537-54.81C577.565 679.14 619.98 600.483 619.98 512c0-88.494-42.416-167.152-108.003-216.741"
		})
	]
});
export default SvgIconOverwriteEmpty;
